// extracted by mini-css-extract-plugin
module.exports = {"Services":"Technologies_Services__3EmzP","select":"Technologies_select__Z-dr7"};